import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Router, Params, NavigationExtras } from '@angular/router';
import { DrawerService } from '@shared/components/drawer/drawer.service';

@Directive({
  selector: '[cmLinkHelper]',
})
export class LinkHelperDirective implements OnInit {
  @Input() cmLinkClass = 'typography__body-1';

  @Output() downloadFile = new EventEmitter<string>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    const tags = this.el.nativeElement.querySelectorAll('a');
    tags.forEach((tag) => {
      this.renderer.addClass(tag, this.cmLinkClass);
      this.renderer.setAttribute(tag, 'style', 'color: #0077CF !important');
      this.renderer.listen(tag, 'click', (event: MouseEvent) => {
        const href = (event.target as HTMLAnchorElement).getAttribute('href');
        if (href && href.startsWith('/api/util/getFile')) {
          event.preventDefault();
          // Extract fileName from href
          const url = new URL(href, window.location.origin);
          const fileName = url.searchParams.get('fileName');
          if (fileName) {
            this.downloadFile.emit(fileName);
          }
        }
      });
    });
  }
}
